<template>
    <div v-if="cards.length" class="bbc-row">
        <div v-for="card in cards" :key="card.key" class="bbc-card stat-card rounded-3 shadow-sm">

            <div class="bbc-content">
                <div class="bbc-inner">
                    <div class="stat-card-icon rounded-2 bbc-icon"
                        :style="{ background: card.colorBg, color: card.color }">
                        <i v-if="card.icon" :class="'fa fa-' + card.icon" aria-hidden="true"></i>
                        <span v-else class="bbc-currency-badge">{{ card.currency }}</span>
                    </div>

                    <div class="stat-card-body">
                        <div class="stat-card-main d-flex align-items-baseline">
                            <span class="stat-card-value">{{ fmt(card.value) }}</span>
                            <span class="stat-card-unit text-muted">{{ card.currency }}</span>
                        </div>
                        <span v-if="card.secondary !== null" class="bbc-secondary text-muted">
                            ≈ {{ fmt(card.secondary) }} EUR
                        </span>
                        <span v-else class="stat-card-label text-muted text-uppercase">{{ card.label }}</span>
                    </div>
                </div>
            </div>

            <div :id="'bbc-spark-' + card.key" class="bbc-spark"></div>
        </div>
    </div>
</template>

<script>
import Highcharts from 'highcharts';

const SPARKLINE_BASE = {
    chart: {
        type: 'areaspline',
        margin: [4, 0, 0, 0],
        backgroundColor: 'transparent',
        animation: false,
    },
    title:   { text: null },
    credits: { enabled: false },
    legend:  { enabled: false },
    xAxis:   { visible: false, type: 'datetime' },
    yAxis:   { visible: false },
    tooltip: { enabled: false },
    plotOptions: {
        areaspline: {
            lineWidth: 1.5,
            marker: { enabled: false },
            states: { hover: { enabled: false } },
        },
    },
};

export default {
    name: 'BankBalanceCards',

    props: {
        dataUrl: { type: String, required: true },
    },

    data() {
        return {
            cards:  [],
            charts: [],
        };
    },

    mounted() {
        this.fetchData();
    },

    beforeDestroy() {
        this.charts.forEach(c => c.destroy());
    },

    methods: {
        async fetchData() {
            try {
                const res  = await axios.get(this.dataUrl);
                this.cards = res.data.cards || [];
                await this.$nextTick();
                this.initCharts();
            } catch (e) {
                console.error('BankBalanceCards: failed to load', e);
            }
        },

        initCharts() {
            this.charts.forEach(c => c.destroy());
            this.charts = [];

            this.cards.forEach(card => {
                if (!card.series || !card.series.length) return;
                const el = document.getElementById('bbc-spark-' + card.key);
                if (!el) return;

                const chart = Highcharts.chart(el, {
                    ...SPARKLINE_BASE,
                    plotOptions: {
                        areaspline: {
                            ...SPARKLINE_BASE.plotOptions.areaspline,
                            color: card.color,
                            fillColor: {
                                linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
                                stops: [
                                    [0, card.color + '55'],
                                    [1, card.color + '00'],
                                ],
                            },
                        },
                    },
                    series: [{ data: card.series }],
                });

                this.charts.push(chart);
            });
        },

        fmt(value) {
            if (value === null || value === undefined) return '—';
            return new Intl.NumberFormat('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value);
        },
    },
};
</script>

